import { format } from 'date-fns';

/**
 * La hora del tramo de al lado en «Será el primer tramo: el siguiente empieza
 * a las…» (30-oct, el usuario): si no es del día del tramo que se mueve, va
 * con su fecha, porque «a las 08:24» del día siguiente no se adivina. `date`
 * es null cuando es el mismo día (o no hay con qué comparar).
 */
export const neighbourTime = (
  iso: string,
  sameDayAs?: string | null
): { time: string; date: string | null } => {
  const time = format(new Date(iso), 'HH:mm');
  if (!sameDayAs) return { time, date: null };
  const day = (value: string) => format(new Date(value), 'yyyy-MM-dd');
  return {
    time,
    date: day(iso) === day(sameDayAs) ? null : format(new Date(iso), 'dd/MM'),
  };
};

/**
 * El aviso de un destino que cabe pero cuyos PK no cuadran con el tramo de al
 * lado (30-oct, el usuario: «Los PK no siguen» no decía qué pasaba ni con
 * cuál). El servidor solo avisa si se PISAN en el mismo sentido; un hueco no
 * avisa. Y el sentido al revés que los PK es otro aviso.
 */
export const pkWarningKey = (code: string): string =>
  code === 'SR_SEGMENT_PK_DIRECTION_MISMATCH'
    ? 'pages:surveillance.transferSegment.directionWarning'
    : code === 'SR_SEGMENT_PK_OVERLAP_PREV'
      ? 'pages:surveillance.transferSegment.pkWarningPrev'
      : 'pages:surveillance.transferSegment.pkWarningNext';
